function fillInAddress() {
  console.log("autocomplete partioto");
  // Get the place details from the autocomplete object.
  var place = autocomplete.getPlace();
  map.setCenter(place.geometry.location);

  if (window.zoomRadius == 15) {
    map.setZoom(11);
  } else if (window.zoomRadius == 30) {
    map.setZoom(10);
  } else if (window.zoomRadius == 50) {
    map.setZoom(9);
  } else {
    map.setZoom(12);
  }

  let compatibleStores = [];

  for (var i = 0; i < stores.length; i++) {
    var position = new google.maps.LatLng(
      stores[i].location.lat,
      stores[i].location.lng,
    );

    if (map.getBounds().contains(position)) {
      var m = [];
      m.push(
        Math.floor(
          google.maps.geometry.spherical.computeDistanceBetween(
            position,
            place.geometry.location,
          ),
        ),
      );
      m.push(stores[i]);

      //add the distance to the store
      stores[i].distance = m[0];
      compatibleStores.push(stores[i]);
    }
  }

  // Sort the stores by distance
  compatibleStores.sort(function (a, b) {
    return a.distance - b.distance;
  });

  compatibleStores.sort((a, b) => {
    if (
      a.tipologia.toLowerCase() === "vitaminstore" &&
      b.tipologia.toLowerCase() !== "vitaminstore"
    ) {
      return -1; // vitaminstore first
    }
  });

  // stores = stores.sort(function (a, b) {
  //   return a[0] - b[0];
  // });

  createStoresList(compatibleStores);
}

function initAutocomplete() {
  // Create the autocomplete object, restricting the search to geographical
  // location types.
  window.autocomplete = new google.maps.places.Autocomplete(
    /** @type {!HTMLInputElement} */ (document.getElementById("autocomplete")),
    { types: ["geocode"] },
  );

  autocomplete.addListener("place_changed", fillInAddress);

  autocomplete.setComponentRestrictions({ country: ["it"] });
}

function geolocate() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });
      autocomplete.setBounds(circle.getBounds());
    });
  }
}

window.initAutocomplete = initAutocomplete;
window.geolocate = geolocate;

function initMap(stores) {
  markers = [];
  var mapOptions = {
    // How zoomed in you want the map to start at (always required)
    zoom: 5,

    // The latitude and longitude to center the map (always required)
    center: new google.maps.LatLng(41.89193, 12.51133), // Roma

    // Or selectively disable specific controls:
    //zoomControl: false,
    mapTypeControl: false,
    //scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,

    // How you would like to style the map.
    // This is where you would paste any style found on Snazzy Maps.
    styles: [
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#e9e9e9" }, { lightness: 17 }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#f5f5f5" }, { lightness: 20 }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#ffffff" }, { lightness: 17 }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }, { lightness: 18 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }, { lightness: 16 }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#dedede" }, { lightness: 21 }],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#ffffff" },
          { lightness: 16 },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#333333" }, { lightness: 40 }],
      },
      { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#f2f2f2" }, { lightness: 19 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#fefefe" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
      },
    ],
  };

  //commento

  // Get the HTML DOM element that will contain your map
  // We are using a div with id="map" seen below in the <body>
  var mapElement = document.getElementById("map");

  // Create the Google Map using our element and options defined above
  window.map = new google.maps.Map(mapElement, mapOptions);

  //add the markers to the map

  for (let i = 0; i < stores.length; i++) {
    let store = stores[i];

    let storeType = store.tipologia.toLowerCase();
    let iconUrl = window.markerRedUrl;
    if (storeType == "vitaminstore") {
      iconUrl = window.markerBlueUrl;
    }

    let latlng = new google.maps.LatLng(store.location.lat, store.location.lng);
    let marker = new google.maps.Marker({
      position: latlng,
      map: window.map,
      title: store.name,
      icon: {
        url: iconUrl,
      },
    });

    markers.push(marker); // Add marker once

    //add the info window
    let infowindow = new google.maps.InfoWindow({
      content: `<div><strong>${store.name}</strong><br>${store.address}<br>${store.email}<br>${store.phone}</div>`,
    });

    // Remove this duplicate line:
    // markers.push(marker);

    //add the click event to the marker
    marker.addListener("click", function () {
      infowindow.open(window.map, marker);
    });
  }
  var clusterStyles = [
    {
      textColor: "white",
      url: "path/to/smallclusterimage.png",
      height: 50,
      width: 50,
    },
    {
      textColor: "white",
      url: "path/to/mediumclusterimage.png",
      height: 50,
      width: 50,
    },
    {
      textColor: "white",
      url: "path/to/largeclusterimage.png",
      height: 50,
      width: 50,
    },
  ];

  const clusterer = new markerClusterer.MarkerClusterer({
    markers,
    map,
    clusterStyles,
  });

  // Function to toggle clustering based on zoom
  function updateClustering() {
    const zoom = map.getZoom();
    if (zoom > 9) {
      // Remove clustering, show individual markers
      clusterer.setMap(null);
      markers.forEach((marker) => marker.setMap(map));
    } else {
      // Enable clustering
      markers.forEach((marker) => marker.setMap(null));
      clusterer.setMap(map);
    }
  }

  // Listen to zoom changes
  map.addListener("zoom_changed", updateClustering);
}

function createStoresList(stores) {
  const storesList = document.getElementById("stores-list");

  //first remove all the children
  while (storesList.firstChild) {
    storesList.removeChild(storesList.firstChild);
  }

  stores.forEach((store) => {
    //if store distance is defined, add it to the store object
    if (store.distance) {
      //store.address += ` - ${store.distance} m`;
    }
    //create a div for each store
    const div = document.createElement("div");

    const type = document.createElement("div");

    let storeType = store.tipologia.toLowerCase();

    if (storeType == "vitaminstore") {
      type.classList.add("store-locator_store_type_vitaminstore");
    } else if (storeType == "vitaminstore point") {
      type.classList.add("store-locator_store_type_vitaminpoint");
    } else {
      type.classList.add("store-locator_store_type_other");
    }

    type.textContent = "";
    div.appendChild(type);

    //add store distance if it exists
    if (store.distance) {
      const distance = document.createElement("div");
      distance.classList.add("store-locator_store_distance");

      let distanceInKm = (store.distance / 1000).toFixed(2);
      if (distanceInKm < 1) {
        distanceInKm = store.distance.toFixed(0);
      } else {
        distanceInKm = distanceInKm + " km";
      }
      store.distance = distanceInKm;

      distance.textContent = `${store.distance}`;
      div.appendChild(distance);
    }

    const title = document.createElement("div");
    title.classList.add("locator_store_name");
    title.textContent = store.name;
    div.appendChild(title);

    //add store address
    const address = document.createElement("div");
    address.classList.add("store-locator_store_summary");
    address.textContent = store.street;
    div.appendChild(address);

    const cityAndCap = document.createElement("div");
    cityAndCap.classList.add("store-locator_store_summary");
    cityAndCap.textContent = store.cityAndCap;
    div.appendChild(cityAndCap);

    // const email = document.createElement("div");
    // email.classList.add("store-locator_store_summary");
    // email.textContent = store.email;
    // div.appendChild(email);

    const phone = document.createElement("div");
    phone.classList.add("store-locator_store_summary");
    phone.textContent = "tel: " + store.phone;
    div.appendChild(phone);

    //add chevron for opening hours toggle
    const chevron = document.createElement("div");
    chevron.classList.add("store-locator_store_summary_chevron");
    chevron.innerHTML = "Vedi orari negozio &#x25BC;"; // downwards arrow
    div.appendChild(chevron);

    //append also the week opening hours if they exist
    let weekHours = "<strong>ORARI NEGOZIO:</strong>";
    weekHours += "<br>Domenica: " + store["Orari di apertura Domenica"];
    weekHours += "<br>Lunedì: " + store["Orari di apertura Lunedì"];
    weekHours += "<br>Martedì: " + store["Orari di apertura Martedì"];
    weekHours += "<br>Mercoledì: " + store["Orari di apertura Mercoledì"];
    weekHours += "<br>Giovedì: " + store["Orari di apertura Giovedì"];
    weekHours += "<br>Venerdì: " + store["Orari di apertura Venerdì"];
    weekHours += "<br>Sabato: " + store["Orari di apertura Sabato"] + "<br>";

    //create div and take this hidden
    const weekHoursDiv = document.createElement("div");
    weekHoursDiv.classList.add("store-locator_store_summary_hours");
    weekHoursDiv.innerHTML = weekHours;
    //weekHoursDiv.style.display = "none"; // hide by default

    //add go to google maps link
    const googleMapsLink = document.createElement("a");

    //align the link to the right
    googleMapsLink.style.float = "right";
    googleMapsLink.style.paddingTop = "1em";
    googleMapsLink.href = `https://www.google.com/maps/search/?api=1&query=${store.location.lat},${store.location.lng}`;
    googleMapsLink.target = "_blank";
    googleMapsLink.textContent = "apri in Google Maps";
    googleMapsLink.classList.add("store-locator_store_summary_maps-link");
    weekHoursDiv.appendChild(googleMapsLink);

    div.appendChild(weekHoursDiv);

    div.addEventListener("click", () => {
      //add the class active to the div
      div.classList.toggle("active");
      map.setCenter(store.location);
      map.setZoom(15);
    });
    storesList.appendChild(div);
  });
}

let jsonStore = false;

async function fetchStores() {
  try {
    const response = await fetch(window.assetDataUrl);
    const data = await response.json();
    return new Promise((resolve) => {
      resolve(data);
    });
  } catch (error) {
    console.error("Error fetching JSON:", error);
  }
}

// Call the async function
jsonStore = window.assetDataUrl;
console.log("jsonStore", jsonStore);
window.stores = [];

for (const store of jsonStore) {
  let singleStore = {};
  let cleanLat = store.Latitudine.replace(",", ".");
  let cleanLng = store.Longitudine.replace(",", ".");
  singleStore.location = {
    lat: parseFloat(cleanLat),
    lng: parseFloat(cleanLng),
  };
  singleStore.name = store.Negozio;
  singleStore.tipologia = store.Tipologia;
  singleStore.address = store.Indirizzo + "," + store.CAP + " " + store.Città;
  singleStore.street = store.Indirizzo;
  singleStore.cityAndCap = store.CAP + " " + store.Città;
  singleStore.email = "";
  singleStore.phone = store.Telefono;
  singleStore["Orari di apertura Domenica"] =
    store["Orari di apertura Domenica"];
  singleStore["Orari di apertura Lunedì"] = store["Orari di apertura Lunedì"];
  singleStore["Orari di apertura Martedì"] = store["Orari di apertura Martedì"];
  singleStore["Orari di apertura Mercoledì"] =
    store["Orari di apertura Mercoledì"];
  singleStore["Orari di apertura Giovedì"] = store["Orari di apertura Giovedì"];
  singleStore["Orari di apertura Venerdì"] = store["Orari di apertura Venerdì"];
  singleStore["Orari di apertura Sabato"] = store["Orari di apertura Sabato"];
  stores.push(singleStore);
}

window.markers = [];
var placeSearch;
window.autocomplete;
var componentForm = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "long_name",
  postal_code: "short_name",
};

window.addEventListener("load", function () {
  window.zoomRadius = 12;

  //get zoom radius from the form
  const radiusForm = document.querySelector("#filter-locator-radius");
  if (radiusForm) {
    radiusForm.addEventListener("change", function (e) {
      const formData = new FormData(radiusForm);
      const formValues = Object.fromEntries(formData.entries());

      if (formValues["radius"]) {
        window.zoomRadius = parseInt(formValues["radius"]);
      } else {
        window.zoomRadius = 12; //default value
      }
      console.log("zoomRadius", window.zoomRadius);

      //if autocomplete is defined, call fillInAddress
      if (window.autocomplete) {
        fillInAddress();
      }
    });
  }

  initMap(stores);

  //sort stores putting vitaminstore first
  stores.sort((a, b) => {
    if (
      a.tipologia.toLowerCase() === "vitaminstore" &&
      b.tipologia.toLowerCase() !== "vitaminstore"
    ) {
      return -1; // vitaminstore first
    }
  });

  createStoresList(stores);

  //when filter-locator form change
  document
    .querySelector("#filter-locator")
    .addEventListener("change", function (e) {
      //get the form values

      let filteredStores = [];

      let currentForm = document.querySelector("#filter-locator");

      const formData = new FormData(currentForm);
      const formValues = Object.fromEntries(formData.entries());
      console.log("formValues", formValues);
      if (formValues["vitaminstore-filter"]) {
        stores.forEach((store) => {
          if (
            store.tipologia.toLowerCase() ==
            formValues["vitaminstore-filter"].toLowerCase()
          ) {
            filteredStores.push(store);
          }
        });
      }

      if (formValues["vitaminpoint-filter"]) {
        stores.forEach((store) => {
          if (
            store.tipologia.toLowerCase() ==
            formValues["vitaminpoint-filter"].toLowerCase()
          ) {
            filteredStores.push(store);
          }
        });
      }

      if (filteredStores.length == 0) {
        filteredStores = stores;
      }

      initMap(filteredStores);
      createStoresList(filteredStores);

      // console.log("filteredStores", filteredStores);
    });

  document.querySelector(".active-geo").addEventListener("click", function () {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async function (position) {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // Reverse geocode the coordinates to get the address
          const geocoder = new google.maps.Geocoder();
          const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
          console.log("geocoder", geocoder);
          geocoder.geocode({ location: latlng }, function (results, status) {
            if (status === "OK") {
              if (results[0]) {
                // Fill the autocomplete input with the detected address
                initAutocomplete();

                // #autocomplete input text value as results[0].formatted_address;

                //get  #autocomplete input text and set it to results[0].formatted_address

                document.querySelector("#autocomplete").value =
                  results[0].formatted_address;

                autocomplete.set("place_id", results[0].place_id);
                autocomplete.set("geometry", results[0].geometry);
                autocomplete.set(
                  "address_components",
                  results[0].address_components,
                );
                autocomplete.set(
                  "formatted_address",
                  results[0].formatted_address,
                );
                autocomplete.set("place_name", results[0].formatted_address);
                autocomplete.set("location", latlng);
                autocomplete.set("viewport", results[0].geometry.viewport);
                autocomplete.set("place", results[0]);
                autocomplete.set("address", results[0].formatted_address);

                fillInAddress();

                // Optionally, trigger the autocomplete logic
                google.maps.event.trigger(autocomplete, "focus");
                google.maps.event.trigger(autocomplete, "keydown", {
                  keyCode: 13,
                });

                // Center the map on the detected location
                map.setCenter(latlng);
                map.setZoom(15);
              } else {
                console.error("No results found");
              }
            } else {
              console.error("Geocoder failed due to: " + status);
            }
          });
        },
        function (error) {
          console.error("Error getting geolocation: ", error);
          alert("Unable to retrieve your location. Please try again.");
        },
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  });
});
